/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiCustomListSignificantFieldConf
 */
export interface InternalApiCustomListSignificantFieldConf {
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomListSignificantFieldConf
     */
    listId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiCustomListSignificantFieldConf
     */
    fields: Array<string>;
}

/**
 * Check if a given object implements the InternalApiCustomListSignificantFieldConf interface.
 */
export function instanceOfInternalApiCustomListSignificantFieldConf(value: object): value is InternalApiCustomListSignificantFieldConf {
    if (!('listId' in value) || value['listId'] === undefined) return false;
    if (!('fields' in value) || value['fields'] === undefined) return false;
    return true;
}

export function InternalApiCustomListSignificantFieldConfFromJSON(json: any): InternalApiCustomListSignificantFieldConf {
    return InternalApiCustomListSignificantFieldConfFromJSONTyped(json, false);
}

export function InternalApiCustomListSignificantFieldConfFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCustomListSignificantFieldConf {
    if (json == null) {
        return json;
    }
    return {
        
        'listId': json['listId'],
        'fields': json['fields'],
    };
}

export function InternalApiCustomListSignificantFieldConfToJSON(json: any): InternalApiCustomListSignificantFieldConf {
    return InternalApiCustomListSignificantFieldConfToJSONTyped(json, false);
}

export function InternalApiCustomListSignificantFieldConfToJSONTyped(value?: InternalApiCustomListSignificantFieldConf | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'listId': value['listId'],
        'fields': value['fields'],
    };
}

